// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addHookButton {
  float: right;
  margin-top: 5px;
}

.fulltablediv {
  padding-top: 15px;
  margin: 0px 20px 0px 30px;
}

.addHookButton button {
  width: 150px;
  height: 40px;
  padding: 20px 10px;
  margin-right: 10px;
  position: fixed;
  right: 10px;
}

.iconsText {
  background-color: transparent;
  color: #666;
  display: flex;
  box-shadow: none;
  height: 20px;
  border: none;
  padding: 0px;
}

.iconsText:hover {
  background-color: transparent;
  box-shadow: none;
}

.buttonclass {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top: 5px;
  right: 0px;
  padding-right: 20px;
}

.topButton button {
  width: 150px;
  height: 40px;
  margin-top: 2px;
  position: absolute;
  right: 25px;
  top: 7px;
}

.buttonAndNotification {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 13px 15px 30px;
}

.notification_alerts {
  overflow: auto;
  height: calc(100vh - 120px);
  margin: 0px 20px 0px 30px;
}

.topProjectButtons button {
  height: 30px;
  padding: 20px 10px;
  display: flex;
}`, "",{"version":3,"sources":["webpack://./routes/notifications/index.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,eAAA;AACF;;AACA;EACE,iBAAA;EACA,yBAAA;AAEF;;AAAA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AAGF;;AADA;EACE,6BAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;AAIF;;AAFA;EACE,6BAAA;EACA,gBAAA;AAKF;;AAFA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,mBAAA;AAKF;;AAHA;EACE,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;AAMF;;AAJA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,4BAAA;AAOF;;AALA;EACE,cAAA;EACA,2BAAA;EACA,yBAAA;AAQF;;AANA;EACE,YAAA;EACA,kBAAA;EACA,aAAA;AASF","sourcesContent":[".addHookButton {\n  float: right;\n  margin-top: 5px;\n}\n.fulltablediv {\n  padding-top: 15px;\n  margin: 0px 20px 0px 30px;\n}\n.addHookButton button {\n  width: 150px;\n  height: 40px;\n  padding: 20px 10px;\n  margin-right: 10px;\n  position: fixed;\n  right: 10px;\n}\n.iconsText {\n  background-color: transparent;\n  color: #666;\n  display: flex;\n  box-shadow: none;\n  height: 20px;\n  border: none;\n  padding: 0px;\n}\n.iconsText:hover {\n  background-color: transparent;\n  box-shadow: none;\n}\n\n.buttonclass {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  position: absolute;\n  top: 5px;\n  right: 0px;\n  padding-right: 20px;\n}\n.topButton button {\n  width: 150px;\n  height: 40px;\n  margin-top: 2px;\n  position: absolute;\n  right: 25px;\n  top: 7px;\n}\n.buttonAndNotification {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 13px 15px 30px;\n}\n.notification_alerts {\n  overflow: auto;\n  height: calc(100vh - 120px);\n  margin: 0px 20px 0px 30px;\n}\n.topProjectButtons button {\n  height: 30px;\n  padding: 20px 10px;\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
